import { render, staticRenderFns } from "./MessagingPage.vue?vue&type=template&id=5f3312f9&scoped=true&"
import script from "./MessagingPage.vue?vue&type=script&lang=js&"
export * from "./MessagingPage.vue?vue&type=script&lang=js&"
import style0 from "./MessagingPage.vue?vue&type=style&index=0&id=5f3312f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3312f9",
  null
  
)

export default component.exports